import ReviewsHome from "@/views/reviews/ReviewsHome.vue";
import ReviewsDailyAssignmentsView from "@/views/reviews/ReviewsDailyAssignmentsView.vue";
import ReviewsClassic from "@/views/reviews/ReviewsClassic.vue";
import ReviewsImport from "@/views/reviews/ReviewsImport.vue";
import ReviewsHomePage from "@/views/reviews/ReviewsHomePage.vue";

const routes = [
  {
    path: "/reviews",
    name: "ReviewsLanding",
    component: ReviewsHomePage,
    meta: { requiresAuth: true, app: "reviews" },
  },
  {
    path: "/reviews/today",
    name: "ReviewsToday",
    component: ReviewsDailyAssignmentsView,
    meta: { requiresAuth: true, app: "reviews" },
  },
  {
    // Keep old path as alias so bookmarks/links still work
    path: "/reviews-home",
    name: "ReviewsHome",
    component: ReviewsDailyAssignmentsView,
    meta: { requiresAuth: true, app: "reviews" },
  },
  {
    path: "/reviews-classic",
    name: "ReviewsClassic",
    component: ReviewsClassic,
    meta: { requiresAuth: true, app: "reviews" },
  },
  {
    path: "/reviews-import",
    name: "ReviewsImport",
    component: ReviewsImport,
    meta: { requiresAuth: true, app: "reviews" },
  },
  {
    path: "/reviews/platform/:platform/location/:location",
    name: "ReviewsByPlatformLocation",
    component: ReviewsClassic,
    meta: { requiresAuth: true, app: "reviews" },
  },
  {
    path: "/reviews-calendar",
    name: "ReviewsCalendar",
    component: ReviewsHome,
    meta: { requiresAuth: true, app: "reviews" },
  },
  {
    path: "/review-assignments",
    name: "ReviewAssignments",
    component: () => import("@/views/settings/ReviewAssignments.vue"),
    meta: { requiresAuth: true, requiresAdmin: true, app: "reviews" },
  },
];

export default routes;
